import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledPDPContentSkeletonContainer = styled.div`
    .PDPContentSkeleton-bone-title {
        width: 25%;
        margin: ${spaceMixin('xs')} 0;
    }

    .PDPContentSkeleton-bone-text-1 {
        width: 90%;
        margin-bottom: ${spaceMixin(0.5)};
    }

    .PDPContentSkeleton-bone-text-2 {
        width: 80%;
        margin-bottom: ${spaceMixin(0.5)};
    }
`;
